import { render, staticRenderFns } from "./WinnerLooks.vue?vue&type=template&id=4b2de494&scoped=true"
import script from "./WinnerLooks.vue?vue&type=script&lang=js"
export * from "./WinnerLooks.vue?vue&type=script&lang=js"
import style0 from "./WinnerLooks.vue?vue&type=style&index=0&id=4b2de494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2de494",
  null
  
)

export default component.exports